import { date } from 'quasar'
import { SESSION_ADMISSION_TYPES } from 'src/models/activity/Activity'
import ActivitySession from 'src/models/activity-session/ActivitySession'
import { IsoDateTime } from 'src/models/model'

const { addToDate } = date

/**
 * Resolves the correct activity session for the activity booking.
 */
class ActivitySessionResolver {
  static #instance = null

  constructor () {
    if (!ActivitySessionResolver.#instance) {
      ActivitySessionResolver.#instance = this
    }
    return ActivitySessionResolver.#instance
  }

  resolve (activityBooking, selectedEntryTime, activitySessionsAndAvailableEntries) {
    if (_.isNil(selectedEntryTime)) {
      return {
        activitySession: null,
        activitySessionEntryTime: null,
        activitySessionExitTime: null
      }
    }

    let resolvedActivitySession = null
    let resolvedActivitySessionId = null
    let resolvedActivitySpaceId = null
    let resolvedActivitySessionEndTime = null
    let resolvedActivitySessionExitTime = null

    if (!_.isNil(activityBooking.activitySession)) {
      const currentActivitySessionMatchesActivitySpaceFilter = _.isNil(activityBooking.config.selectedActivitySpaceId) || activityBooking.activitySession.activitySpaceId === activityBooking.config.selectedActivitySpaceId
      const entryTimesForCurrentActivitySession = _(activitySessionsAndAvailableEntries).find(({ activitySessionId }) => activitySessionId === activityBooking.activitySession.id).availableEntries

      if (currentActivitySessionMatchesActivitySpaceFilter && activityBooking.isEntryTimeAvailable(selectedEntryTime, entryTimesForCurrentActivitySession)) {
        resolvedActivitySession = activityBooking.activitySession
        resolvedActivitySessionId = activityBooking.activitySession.id
        resolvedActivitySessionEndTime = activityBooking.activitySession.endTime
      }
    }

    if (_.isNil(resolvedActivitySessionId)) {
      const resolvedActivitySessionObject = _.find(activitySessionsAndAvailableEntries, ({ activitySpaceId, availableEntries }) => {
        const activitySessionMatchesActivitySpaceFilter = _.isNil(activityBooking.config.selectedActivitySpaceId) || activitySpaceId === activityBooking.config.selectedActivitySpaceId
        return activitySessionMatchesActivitySpaceFilter && activityBooking.isEntryTimeAvailable(selectedEntryTime, availableEntries)
      })

      if (_.isNil(resolvedActivitySessionObject)) {
        return {
          activitySession: null,
          activitySessionEntryTime: null,
          activitySessionExitTime: null
        }
      }

      resolvedActivitySessionId = resolvedActivitySessionObject.activitySessionId
      resolvedActivitySpaceId = resolvedActivitySessionObject.activitySpaceId
      resolvedActivitySessionEndTime = resolvedActivitySessionObject.activitySessionEndTime
    }

    resolvedActivitySession ||= new ActivitySession({
      id: resolvedActivitySessionId,
      activitySpaceId: resolvedActivitySpaceId
    })

    if (activityBooking.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.ACTIVITY_UNIT_DYNAMIC) {
      resolvedActivitySessionExitTime = new IsoDateTime(addToDate(selectedEntryTime, {
        minutes: activityBooking.activity.activityUnitDurationMinutes * activityBooking.activityUnitQuantity * activityBooking.numSelectedTickets
      }))
    } else if (activityBooking.activity.sessionAdmissionType === SESSION_ADMISSION_TYPES.ACTIVITY_UNIT_FIXED) {
      resolvedActivitySessionExitTime = new IsoDateTime(addToDate(selectedEntryTime, {
        minutes: activityBooking.activity.activityUnitDurationMinutes * activityBooking.activityUnitQuantity
      }))
    } else {
      resolvedActivitySessionExitTime = new IsoDateTime(resolvedActivitySessionEndTime)
    }

    return {
      activitySession: resolvedActivitySession,
      activitySessionEntryTime: selectedEntryTime,
      activitySessionExitTime: resolvedActivitySessionExitTime
    }
  }
}

const activitySessionResolver = new ActivitySessionResolver()
export default activitySessionResolver
